import { useMemo } from "react";

import { Group } from "@mantine/core";
import { useTranslation } from "react-i18next";


import { DatePicker, Select } from "components";

import { KpiPeriod } from "types";

import classes from "./kpi.module.css";

export type { KpiPeriod };

interface KpiPeriodFilterProps {
  period: KpiPeriod;
  onPeriodChange: (period: KpiPeriod) => void;
  dateFrom: Date | null;
  dateTo: Date | null;
  onDateFromChange: (date: Date | null) => void;
  onDateToChange: (date: Date | null) => void;
}

const KpiPeriodFilter = ({
  period,
  onPeriodChange,
  dateFrom,
  dateTo,
  onDateFromChange,
  onDateToChange,
}: KpiPeriodFilterProps) => {
  const { t } = useTranslation();

  const periodOptions = useMemo(
    () => [
      { value: "DAILY", label: t("profilePage.kpi.period.options.day") },
      { value: "WEEKLY", label: t("profilePage.kpi.period.options.week") },
      { value: "BIWEEKLY", label: t("profilePage.kpi.period.options.twoWeeks") },
      { value: "MONTHLY", label: t("profilePage.kpi.period.options.month") },
      { value: "QUARTERLY", label: t("profilePage.kpi.period.options.quarter") },
      { value: "YEARLY", label: t("profilePage.kpi.period.options.year") },
      { value: "CUSTOM", label: t("profilePage.kpi.period.options.custom") },
    ],
    [t],
  );

  const isCustom = period === "CUSTOM";

  return (
    <Group gap="sm" align="flex-end" wrap="wrap">
      <Select
        className={classes.periodSelect}
        data={periodOptions}
        value={period}
        onChange={(value) => onPeriodChange((value as KpiPeriod) ?? "MONTHLY")}
        allowDeselect={false}
        mb={0}
      />

      {isCustom ? (
        <Group gap="sm" align="flex-end" className={classes.dateRange}>
          <DatePicker
            label={t("profilePage.kpi.period.from")}
            value={dateFrom}
            onChange={onDateFromChange}
            clearable
          />
          <DatePicker
            label={t("profilePage.kpi.period.to")}
            value={dateTo}
            onChange={onDateToChange}
            clearable
          />
        </Group>
      ) : null}
    </Group>
  );
};

export default KpiPeriodFilter;
